<template>
    <Transition name="modal-fade">
        <div v-if="isdisplay" class="cf-overlay" @click.self="close">
            <Transition name="modal-slide">
                <div v-if="isdisplay" class="cf-dialog cf-dialog--lg">

                    <!-- Header -->
                    <div class="cf-modal-head cf-dialog-head">
                        <div class="cf-modal-head__main">
                            <span class="cf-modal-head__icon"><i class="ri-store-2-line"></i></span>
                            <div>
                                <h4 class="cf-dialog-title">{{ titlemodal }}</h4>
                                <p class="cf-modal-head__sub">Tarifs par entrepôt</p>
                            </div>
                        </div>
                        <button @click="close" type="button" class="cf-dialog-close" aria-label="Fermer"><i class="ri-close-line"></i></button>
                    </div>

                    <!-- Body -->
                    <div class="cf-dialog-body">
                        <div class="space-y-2">
                            <label class="cf-field-label">Entrepôt</label>
                            <input :value="mypv.mg.name" type="text" class="cf-inp" disabled>
                        </div>

                        <div class="mt-3 grid lg:grid-cols-2 gap-4">
                            <div class="space-y-2">
                                <label class="cf-field-label">Seuil d'alerte (Stock minimum)</label>
                                <input v-model="mypv.stockminimum" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">Stock maximum</label>
                                <input v-model="mypv.stockmaximum" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente }}</label>
                                <input v-model="mypv.pu" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente1 }}</label>
                                <input v-model="mypv.pu1" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente2 }}</label>
                                <input v-model="mypv.pu2" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente3 }}</label>
                                <input v-model="mypv.pu3" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente4 }}</label>
                                <input v-model="mypv.pu4" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente5 }}</label>
                                <input v-model="mypv.pu5" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente6 }}</label>
                                <input v-model="mypv.pu6" min="0" type="number" class="cf-inp" required>
                            </div>
                            <div class="space-y-2">
                                <label class="cf-field-label">{{ datainputlibelleforms.prixvente7 }}</label>
                                <input v-model="mypv.pu7" min="0" type="number" class="cf-inp" required>
                            </div>
                        </div>
                    </div>

                    <!-- Footer -->
                    <div class="cf-dialog-foot">
                        <button @click="close" type="button" class="ti-btn ti-btn-secondary-full">Fermer</button>
                        <button @click="ajouterselectedmagasin" type="button" class="ti-btn ti-btn-primary-full">
                            <i class="ri-check-line align-middle"></i> Modifier
                        </button>
                    </div>

                </div>
            </Transition>
        </div>
    </Transition>
</template>

<script>


    export default {
        /* eslint-disable */
        name: "formsupp",

        watch: {
            searchword: function(newvalue,oldvalue){

                this.page=1

            },
            searchtrierletableau: function(newvalue,oldvalue){

                this.page=1

               // console.log("  oldvalue  searchtrierletableau        **************** ",oldvalue)
               // console.log("  newvalue   searchtrierletableau       **************** ",newvalue)

            }

        },
        computed:{

            displayedPages() {
                const start = Math.max(1, this.page - 5);
                const end = Math.min(this.pages.length, start + 9);

                let result = [];

                if (start > 1) {
                    result.push(1);
                    if (start > 2) {
                        result.push('...');
                    }
                }

                for (let i = start; i <= end; i++) {
                    result.push(i);
                }

                if (end < this.pages.length) {
                    if (end < this.pages.length - 1) {
                        result.push('...');
                    }
                    result.push(this.pages.length);
                }

                return result;
            },
            filterdatatable(){

                let mvalue=this.datatable;

                //this.page=this.Defaultpage;
                this.perPage=this.DefaultperPage;

               /* if (this.searchtrierletableau!==''){
                    let t=this;

                    mvalue = mvalue.filter( function (post) {

                        return   post.etatcontrat===parseFloat(t.searchtrierletableau)

                    })

                }*/


                if (this.searchword!==''){
                    let t=this;


                    mvalue = mvalue.filter( function (post) {
                        return    post.name.toLowerCase().includes(t.searchword.toLowerCase())
                        /*||
                        post.nameclient.toLowerCase().includes(t.searchword.toLowerCase()) ||
                        post.numbon.toLowerCase().includes(t.searchword.toLowerCase())*/
                    })

                }



                return this.paginate(mvalue) ;
            },
        },
        components: {

            /*appmenu,*/

        },

        data() {
            return {
                isdisplay:false,
                titlemodal:"",
                datapv:[],
                datainputlibelleforms:[],
                typedoc:"",
                messageerror:"",
                messagesucces:"",
                btnaction:"",

                mypv:{
                    min:0,
                    max:0,
                    mtyprix:'prixvente',
                    pu:0
                },
                indextable:0,


                searchword:"",
                searchtrierletableau:"",

                posts : [''],
                page: 1,
                // perPage: 100,
                perPage: 50,
                Defaultpage: 1,
                DefaultperPage: 50,
                pages: [],
            };
        },
        methods: {


            ajouterselectedmagasin(){


                this.selected('add',this.mypv)

            },



            close(){

                this.isdisplay=false;

            },




            selected(option,datavalue){

                // Suppose que vous avez un objet représentant l'élément sélectionné
                const elementSelectionne = { typ:option, value: this.mypv,index:this.indextable};

                // Émettre un événement personnalisé avec l'élément sélectionné
                this.$emit('elementSelectionnemodifcationtarifentrepot', elementSelectionne);


                // Fermer le modal ou effectuer d'autres actions nécessaires
                this.isdisplay=false;
            },

            show(titlemodal,datainputlibelleforms,datapv,index){
                this.messagesucces="";
                this.messageerror="";
                this.titlemodal=titlemodal

                //this.datatable=listdata



                this.datainputlibelleforms=datainputlibelleforms
                //this.datapv=datapv
                this.indextable=index
                this.mypv=datapv

                this.isdisplay=true;

            },






            //****************************************************************//

            setPages (posts) {
                this.pages=[];
                // let numberOfPages = Math.ceil(this.datatable.length / this.perPage);
                let numberOfPages = Math.ceil(posts.length / this.perPage);
                for (let index = 1; index <= numberOfPages; index++) {

                    this.pages.push(index);
                }
            },
            paginate (posts) {

                this.setPages(posts)
                let page = this.page;
                let perPage = this.perPage;
                let from = (page * perPage) - perPage;
                let to = (page * perPage);

                let $res=posts.slice(from, to)

                if ($res.length>0){
                    return $res;
                }else{

                    return posts;
                }

                // return  posts.slice(from, to);
            }



        },
        mounted() {

            // this.loaddata();
        }




    }
</script>

<style scoped>
/* Charte cf-/ds- : tokens uniquement (light-only) */
.cf-overlay { position:fixed; inset:0; z-index:1000; display:flex; align-items:center; justify-content:center; padding:1rem; background:rgb(15 23 42 / 0.45); }
.cf-dialog { width:100%; background:#fff; border-radius:var(--cf-radius); box-shadow:var(--cf-shadow-md); display:flex; flex-direction:column; max-height:90vh; overflow:hidden; }
.cf-dialog--lg { max-width:760px; }
.cf-dialog-head { display:flex; align-items:center; justify-content:space-between; padding:1rem 1.25rem; border-bottom:1px solid var(--cf-border); flex-shrink:0; }
.cf-dialog-title { margin:0; font-size:0.95rem; font-weight:700; color:var(--cf-ink-strong); }
.cf-dialog-close { height:2rem; width:2rem; flex-shrink:0; display:inline-flex; align-items:center; justify-content:center; border-radius:var(--cf-radius-sm); border:none; background:var(--cf-surface-alt); color:var(--cf-muted); cursor:pointer; transition:all .15s; }
.cf-dialog-close:hover { background:#fee2e2; color:rgb(var(--danger)); }
.cf-dialog-body { padding:1.1rem 1.25rem; overflow-y:auto; flex:1; }
.cf-dialog-foot { display:flex; align-items:center; justify-content:flex-end; gap:0.6rem; padding:0.9rem 1.25rem; border-top:1px solid var(--cf-border); background:var(--cf-surface); flex-shrink:0; }

.cf-field-label { display:block; font-size:0.72rem; text-transform:uppercase; letter-spacing:0.03em; font-weight:600; color:var(--cf-muted); margin-bottom:6px; }
.cf-inp { width:100%; height:40px; padding:0 12px; border-radius:var(--cf-radius-sm); border:1px solid rgb(var(--input-border,203 213 225)); background:#fff; color:var(--cf-ink); font-size:0.82rem; outline:none; transition:border-color 0.2s, box-shadow 0.2s; }
.cf-inp:focus { border-color:rgb(var(--primary)); box-shadow:0 0 0 3px rgb(var(--primary) / 0.10); }
.cf-inp:disabled { background:var(--cf-surface); color:var(--cf-muted); cursor:not-allowed; }

.modal-fade-enter-active, .modal-fade-leave-active { transition:opacity 0.25s ease; }
.modal-fade-enter-from, .modal-fade-leave-to { opacity:0; }
.modal-slide-enter-active, .modal-slide-leave-active { transition:all 0.25s ease; }
.modal-slide-enter-from, .modal-slide-leave-to { opacity:0; transform:translateY(-16px); }

@media (max-width:768px) { .cf-dialog--lg { max-width:100%; } }
</style>
